import { render, staticRenderFns } from "./UserInputBar.vue?vue&type=template&id=17f88d94&"
import script from "./UserInputBar.vue?vue&type=script&lang=js&"
export * from "./UserInputBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports